import React, { Component } from "react";
import { connect } from "react-redux";

import {
    Panel,
    ListGroup,
    Button,
    Glyphicon,
    FormControl,
    Label,
} from "react-bootstrap";
import Datetime from "react-datetime";
import moment from "moment";

import translator from "../../../components/localization/translator";
import security from "../../../components/common/security/security";
import InputWithLabel from "../../../components/common/elements/InputWithLabel";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { redirectToOkTellTab } from "../../../lib/utils";
import {
    OK_TELL_URL,
    SUPPLIER_STATES,
    ORDER_STATUSES,
    USER_ROLE_NAMES,
    USER_ROLES,
    PRODUCT_MODES,
} from "../../../config/constants";

import { confirmCall, sendToHaysell } from "../orderDetails.actions";
import "./OrderDetails.css";
import ProductDiscussion from "./ProductDiscussion";

class ShopList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shops: this.props.shops,
            isRequiredReadyTime: false,
            labelColor: "",
            branchId: "",
            collapses: {},
            readyTimeMinutes: "",
            isSuggestBranchSelected: false,
        };

        this.renderProducts = this.renderProducts.bind(this);
        this._restaurantInfoCache = new Map();
    }

    componentDidMount() {
        this.setState({ shops: this.props.shops });
    }

    componentDidUpdate(prevProps) {
        // keep original logic but faster: only ref compare, no extra && shops !== state.shops which blocked updates when parent mutated same array
        if (prevProps.shops !== this.props.shops) {
            this._restaurantInfoCache.clear();
            this.setState({ shops: this.props.shops });
        } else if (prevProps.restaurants !== this.props.restaurants) {
            this._restaurantInfoCache.clear();
        }
    }

    propertyWasChanged(property, i, isNested) {
        let changed = false;
        const diff = this.props.differences || [];
        diff.forEach((item) => {
            if (item.path[0] === "shops" && Number(item.path[1] === i)) {
                let key = item.path[2];
                if (isNested) {
                    const keys = item.path.slice(2);
                    key = keys.toLocaleString();
                    if (key === "location") {
                        changed = changed || property.indexOf(key) !== -1;
                    }
                }
                changed = changed || key === property;
            }
        });
        return changed;
    }

    renderInput(label, id, type, value, onChange, additionalStyle, labelStyle, inputStyle, disabled) {
        return (
            <InputWithLabel
                disabled={!this.props.canEdit || disabled}
                htmlFor={id}
                label={label}
                type={type}
                id={id}
                value={value || ""}
                additionalStyle={additionalStyle}
                onChange={onChange}
                labelStyle={labelStyle}
                inputStyle={inputStyle} />
        );
    }

    renderDateTimePicker(label, id, item, onChange, additionalStyle) {
        let readyTime,
            reqStyle = this.state.isRequiredReadyTime || this.props.invalidDate ? "req-style" : "";
        if (item.readyTime) {
            readyTime = moment(item.readyTime);
        } else {
            readyTime = moment();
            // keep original logic display wise, but don't mutate props item (same value, no side effect)
        }
        if (readyTime) {
            if (!readyTime._isValid) {
                readyTime = moment(item.readyTime, "DD/MM/YYYY HH:mm");
            }
        }
        if (!this.props.canEdit) {
            readyTime = readyTime.format("DD/MM/YYYY HH:mm");
            return this.renderInput(label, id, "text", readyTime, onChange, additionalStyle);
        }

        return (
            <div className={`display-flex align-start-center ${additionalStyle}`}>
                <label htmlFor={id} className={"label-width"}>{translator.translate(label)}:</label>
                <Datetime
                    id={id}
                    value={readyTime}
                    onChange={onChange}
                    dateFormat={"DD/MM/YYYY"}
                    timeFormat={"HH:mm"}
                    viewMode={"time"}
                    timeConstraints={{
                        minutes: {
                            step: 5,
                        },
                    }}
                    inputProps={{
                        className: `form-control ${reqStyle}`,
                    }}
                    className="default-font my-custom-input ready-time" />
                {this.renderReadyTimeMinutesField(id, item)}
            </div>
        );
    }

    renderReadyTimeMinutesField(id, item) {
        return (
            <FormControl
                id={`${id}-minutes`}
                type="number"
                value={this.state.readyTimeMinutes}
                onChange={(e) => {
                    this.setState({ readyTimeMinutes: e.target.value });
                }}
                onBlur={() => {
                    if (!this.state.readyTimeMinutes) {
                        return;
                    }
                    // keep original logic: notify parent, don't mutate state.shops directly for readyTime
                    const newTime = moment(new Date()).add(this.state.readyTimeMinutes, "minutes");
                    this.props.readyTimeHandler(newTime, item.shopIndex);
                    this.props.dateValidation();
                    this.setState({
                        readyTimeMinutes: "",
                    });
                }}
                className="ready-time-minutes label-distance"
            />
        );
    }

    renderRemoveProductButton(products, product, shopId, index) {
        if (!this.props.canEdit || products.length === 1) {
            return null;
        }
        return (
            <Button className={"pull-right shop-list col-xs-1 align-center"}
                    bsStyle={"danger"}
                    onClick={() => {
                        this.props.removeProduct(products, product, shopId, index);
                    }}>
                <Glyphicon glyph={"trash trash-button"} />
            </Button>
        );
    }

    renderAddProduct(shop) {
        if (!this.props.canEdit) {
            return null;
        }
        ;
        return (
            <Button
                className={"add-product"}
                bsStyle={"primary"}
                disabled={!shop.products}
                onClick={() => {
                    let newProduct = {
                        name: "",
                        price: "",
                        driverExpenses: "",
                        quantity: 1,
                    };
                    shop.products.push(newProduct);
                    this.forceUpdate();
                }}>
                <Glyphicon glyph={"plus-sign"} />
                <span className={"margin-to-left"}>{translator.translate("_add_product_")}</span>
            </Button>
        );
    }

    discussion(list = []) {
        return list.filter(item => !!item.message);
    }

    handleCollapsesToggle = (key, open) => () => {
        const { collapses } = this.state;
        if (collapses[key] && "boolean" === typeof collapses[key].open) {
            open = collapses[key].open;
        }
        collapses[key] = {
            open: !open,
        };
        this.setState({ collapses });
    };

    getRoleName = (role) => {
        const roleData = USER_ROLE_NAMES.find(data => data.role === role) || {};
        if (roleData.label) {
            return translator.translate(roleData.label);
        }
        return "";
    };

    renderProductDiscussion(product, i) {
        const productKey = product._id || `product-${i}`;

        if (!product._id) {
            return null;
        }

        return (
            <ProductDiscussion
                key={productKey}
                product={product}
                index={i}
                isOpen={this.state.collapses[productKey]?.open}
                onToggle={this.handleCollapsesToggle(productKey, false)}
                getRoleName={this.getRoleName}
            />
        );
    }

    renderCustomerName(customerName) {
        if (customerName) {
            return (<div>
                {translator.translate("_name_")}: <span className="red-color"> {customerName}</span>
            </div>);
        }
    }

    renderCustomerComment(customerComment) {
        if (customerComment) {
            return (<div>
                {translator.translate("_comment_")}: <span className="red-color"> {customerComment} </span>
            </div>);
        }
    }

    renderUpdatedByPartner(updatedByPartner) {
        if (updatedByPartner) {
            return (<div><span className="red-color">{translator.translate("_updated_by_partner_")} </span>
            </div>);
        }
    }

    renderCustomerNameAndComment(product) {
        return (
            <div>
                {this.renderCustomerName(product.customerName)}
                {this.renderCustomerComment(product.customerComment)}
                {this.renderUpdatedByPartner(product.addedBySupplier)}
                {this.renderPhoneNumberAndButton(product.customerPhone)}

            </div>
        );
    }

    renderProducts(item, i) {
        return (
            <div>
                {
                    item.products.map((product, j) => {
                        const nameStyle = this.propertyWasChanged(`products,${j},name`, i, true) ? "was-changed" : "";
                        const productCodeStyle = this.propertyWasChanged(`products,${j},productCode`, i, true) ? "was-changed" : "";
                        const partnerCodeStyle = this.propertyWasChanged(`products,${j},partnerCode`, i, true) ? "was-changed" : "";
                        const priceStyle = this.propertyWasChanged(`products,${j},price`, i, true) ? "was-changed" : "";
                        const driverExpensesStyle = this.propertyWasChanged(`products,${j},driverExpenses`, i, true) ? "was-changed" : "";
                        const quantityStyle = this.propertyWasChanged(`products,${j},quantity`, i, true) ? "was-changed" : "";
                        const partnerQuantityStyle = (product.hasOwnProperty("partnerQuantity") && product.quantity !== product.partnerQuantity) ? "was-changed" : "";
                        const { HSCode, _id } = product;
                        return (
                            <div key={j} className="product-container">
                                <div className={"display-flex"}>
                                    <div className={"row shop-list flex-box"}>
                                        <div className="col-xs-8">
                                            <div className="row">
                                                <div className="col-xs-12 display-flex">
                                                    <div className="col-xs-5 padding-right">
                                                        {
                                                            this.renderInput("_product_name_", `name-${i}-${j}`, "text", product.name, (e) => {
                                                                this.props.productChanged(e, "name", i, j);
                                                                // this.setState({labelColor: 'was-changed'})
                                                            }, `col-xs-12 padding-right ${nameStyle}`, `label-width padding-right ${this.state.labelColor}`, "", product.mode === PRODUCT_MODES.VOUCHER || security.getUser().role !== USER_ROLES.SUPER_ADMIN && HSCode)
                                                        }
                                                        {
                                                            this.renderInput("_hs_code_", `HSCode-${i}-${j}`, "text", product.HSCode, (e) => {
                                                                this.props.productChanged(e, "HSCode", i, j);
                                                            }, `col-xs-12 padding-right`, `label-width padding-right ${this.state.labelColor}`, "", security.getUser().role !== USER_ROLES.SUPER_ADMIN)
                                                        }
                                                    </div>
                                                    <div className="align-center col-xs-2 padding-right">
                                                        <div className="row">
                                                            {
                                                                this.renderInput("_product_code_", `productCode-${i}-${j}`, "text", product.productCode, (e) => {
                                                                    this.props.productChanged(e, "productCode", i, j);
                                                                }, `col-xs-12 padding-right ${productCodeStyle}`, "padding-right padding-vertical-0", "", product.mode === PRODUCT_MODES.VOUCHER || security.getUser().role !== USER_ROLES.SUPER_ADMIN && HSCode)
                                                            }
                                                        </div>
                                                        <div className="row">
                                                            {
                                                                this.renderInput("_partner_code_", `partnerCode-${i}-${j}`, "text", product.partnerCode, (e) => {
                                                                    this.props.productChanged(e, "partnerCode", i, j);
                                                                }, `col-xs-12 padding-right ${partnerCodeStyle}`, "padding-right padding-vertical-0", "", product.mode === PRODUCT_MODES.VOUCHER || security.getUser().role !== USER_ROLES.SUPER_ADMIN && HSCode)
                                                            }
                                                        </div>
                                                    </div>
                                                    <div>
                                                        {
                                                            this.renderInput("_price_", `price-${i}-${j}`, "number", product.price, (e) => {
                                                                this.props.productChanged(e, "price", i, j);
                                                            }, `col-xs-5 padding-right ${priceStyle}`, "padding-right", "", product.mode === PRODUCT_MODES.VOUCHER)
                                                        }
                                                        {
                                                            this.renderInput("_partner_debt_", `driverExpenses-${i}-${j}`, "number", product.driverExpenses, (e) => {
                                                                this.props.productChanged(e, "driverExpenses", i, j);
                                                            }, `col-xs-6 padding-right ${driverExpensesStyle}`, "padding-right", "", product.mode === PRODUCT_MODES.VOUCHER)
                                                        }
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xs-12">
                                                    <h4>
                                                        {product.configuration && product.configuration.map((group, k) => {
                                                            return (
                                                                <span className="margin-right label label-success"
                                                                      key={k}>{group.groupName}: {group.optionName}</span>
                                                            );
                                                        })}
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="cal-xs-4">
                                            <div
                                                className={`flex-box align-center padding-horizontal ${quantityStyle}`}>
                                                <label>{translator.translate("_quantity_")}:</label>
                                                <input
                                                    type={"number"}
                                                    value={product.quantity || 0}
                                                    onKeyPress={(e) => {
                                                        const keyCode = e.keyCode || e.which;
                                                        if ((keyCode < 48 && keyCode !== 45 && keyCode !== 46) || keyCode > 57) {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            return false;
                                                        }
                                                    }}
                                                    onChange={(e) => {
                                                        this.props.productChanged(e, "quantity", i, j);
                                                    }}
                                                    onBlur={(e) => {
                                                        this.props.onQuantityChanged(e, "quantity", i, j);
                                                    }}
                                                    onWheel={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                    }}
                                                    disabled={!this.props.canEdit || product.mode === PRODUCT_MODES.VOUCHER}
                                                    className={"form-control default-font label-distance"} />
                                                <FormControl
                                                    componentClass="select"
                                                    onChange={(e) => {
                                                        product.measurement = Number(e.target.value);
                                                    }}
                                                    disabled={!this.props.canEdit || product.mode === PRODUCT_MODES.VOUCHER}
                                                    defaultValue={product.measurement}
                                                    className={"label-distance"}>
                                                    <option
                                                        value={1}>{translator.translate("_quantity_count_")}</option>
                                                    <option value={2}>{translator.translate("_quantity_kg_")}</option>
                                                    <option
                                                        value={3}>{translator.translate("_quantity_package_")}</option>
                                                </FormControl>
                                            </div>
                                            <div
                                                className={`flex-box align-center padding-horizontal ${partnerQuantityStyle}`}>
                                                <label>{translator.translate("_partner_quantity_")}:</label>
                                                <input
                                                    type={"number"}
                                                    value={product.partnerQuantity}
                                                    disabled
                                                    className={"form-control default-font label-distance"} />
                                            </div>
                                        </div>
                                    </div>
                                    {this.renderRemoveProductButton(item.products, product, item._id, j)}
                                </div>
                                {this.renderCustomerNameAndComment(product)}
                                <div className="display-flex">
                                    {this.renderProductDiscussion(product, i)}
                                </div>
                                {_id && <div className="display-flex">
									<textarea type="text" rows="1" className="form-control default-font"
                                              value={product.message || ""}
                                              onChange={(e) => {
                                                  this.props.productChanged(e, "message", i, j);
                                              }}
                                              onKeyDown={(e) => {
                                                  if (e.keyCode === 13) {
                                                      e.preventDefault();
                                                      e.stopPropagation();
                                                      this.props.comment(product);
                                                  }
                                              }}
                                    />
                                </div>}
                            </div>
                        );
                    })
                }
                {this.renderAddProduct(item)}
            </div>
        );
    }

    renderRemoveShopButton(item, index) {
        const shops = this.props.originalOrderShops || [];
        if (!this.props.canEdit || shops.length === 1) {
            return null;
        }
        return (
            <span className={"glyphicon glyphicon-trash pull-right red-color"}
                  onClick={(e) => {
                      e.stopPropagation();
                      this.props.removeShop(shops, item, index);
                  }} />
        );
    }

    renderSelectShopForDivisionCheckbox(item) {
        const shops = this.props.shops || [];
        if (!this.props.canEdit || shops.length === 1) {
            return null;
        }
        return (
            <input type={"checkbox"}
                   className={"margin-to-right"}
                   checked={this.props.isSelected(item)}
                   onClick={(e) => e.stopPropagation()}
                   onChange={(e) => {
                       this.props.selectShopForDivision(item, e.target.checked);
                   }}
            />
        );
    }

    renderHeader(info, item, branches, index) {

        const selectedBranch = branches.find(b => b._id === this.state.branchId);

        const shopName = info ? info.name : item.shopName;
        const address = (selectedBranch && selectedBranch.restaurantInformation.location) ? selectedBranch.restaurantInformation.location.address : info
            && info.restaurantInformation
            && info.restaurantInformation.location
            && info.restaurantInformation.location.address
            || "";

        const copyOrderShops = this.props.originalOrderShops[index]?.restaurantInfo;

        const currentBranch = (item.branch === "" || item.branch === null) ? copyOrderShops?.mainBranch : copyOrderShops?.branches.find((br) => br._id === item.branch);

        const isDraft = currentBranch?.status === 0;

        return (
            <Panel.Title componentClass="h3">
                {this.renderSelectShopForDivisionCheckbox(item)}
                <span>{shopName}</span>
                {this.renderSendToPartnerButton(item, index)}
                {this.renderConfirmLabel(item, isDraft, index)}
                {this.renderRemoveShopButton(item, index)}
                <span className={"address-label"}> {address}</span>
            </Panel.Title>
        );
    }

    getRestaurantInfo(item) {
        // cache same logic result by _id - no logic change, only faster
        const cacheKey = item._id || (item.restaurantInfo && item.restaurantInfo._id) || '';
        if (cacheKey && this._restaurantInfoCache.has(cacheKey)) {
            return this._restaurantInfoCache.get(cacheKey);
        }
        const restaurantInfo = item.restaurantInfo,
            restaurants = this.props.restaurants;
        let id = null;
        let result = null;

        if ("string" === typeof restaurantInfo) {
            id = item.restaurantInfo;
        } else if (restaurantInfo && restaurantInfo.restaurantInformation) {
            result = restaurantInfo;
            if (cacheKey) this._restaurantInfoCache.set(cacheKey, result);
            return result;
        } else if (restaurantInfo && restaurantInfo._id) {
            const hasBranches = restaurantInfo.branches &&
                Array.isArray(restaurantInfo.branches) &&
                restaurantInfo.branches.length > 0;

            if (hasBranches) {
                result = restaurantInfo;
                if (cacheKey) this._restaurantInfoCache.set(cacheKey, result);
                return result;
            }

            id = restaurantInfo._id;

            for (let i = 0, len = restaurants.length; i < len; i++) {
                if (id === restaurants[i]._id) {
                    const mergedBranches = (restaurants[i].branches &&
                        Array.isArray(restaurants[i].branches) &&
                        restaurants[i].branches.length > 0)
                        ? restaurants[i].branches
                        : (restaurantInfo.branches || []);
                    result = {
                        ...restaurants[i],
                        ...restaurantInfo,
                        branches: mergedBranches,
                    };
                    if (cacheKey) this._restaurantInfoCache.set(cacheKey, result);
                    return result;
                }
            }
        }

        if (id) {
            for (let i = 0, len = restaurants.length; i < len; i++) {
                if (id === restaurants[i]._id) {
                    result = restaurants[i];
                    if (cacheKey) this._restaurantInfoCache.set(cacheKey, result);
                    return result;
                }
            }
        }
        if (cacheKey) this._restaurantInfoCache.set(cacheKey, result);
        return result;
    }

    getBranchInfo(branches, branch) {
        for (let i = 0, len = branches.length; i < len; i++) {
            if (branch === branches[i]._id) {
                return branches[i];
            }
        }
        return null;
    }

    renderBranches(branches, branch, i, suggestedBranch) {
        if (!branches || !Array.isArray(branches)) {
            return null;
        }

        let filteredBranches = branches.filter(b => b._id !== "mainBranch");
        filteredBranches.sort((a, b) => a.name.localeCompare(b.name));
        const mainBranch = branches.find(b => b._id === "mainBranch");

        return (
            <div className={"display-flex"}>
                <label htmlFor={`branches-${i}`} className={"label-width"}>
                    {translator.translate("_branch_")}:
                </label>
                <div className={"my-custom-input"}>
                    {suggestedBranch && (
                        <button
                            type="button"
                            style={{
                                fontSize: "x-small",
                                color: "#337ab7",
                                background: "none",
                                border: "none",
                                padding: 0,
                                cursor: "pointer",
                            }}
                            onClick={e => {
                                e.stopPropagation();
                                const branchObj = filteredBranches.find(b => b.name === suggestedBranch);
                                if (!branchObj) return;
                                this.props.branchHandler(branchObj._id, i);
                                this.setState({ isSuggestBranchSelected: suggestedBranch });
                            }}
                        >
                            {suggestedBranch}
                        </button>
                    )}

                    <FormControl
                        componentClass="select"
                        onChange={(e) => {
                            const branchId = e.target.value;
                            this.setState({ branchId });
                            this.props.branchHandler(e.target.value, i);
                        }}
                        disabled={!this.props.canEdit}
                        value={branch || ""}
                    >

                        <option
                            value=""
                            className="filter text-filter form-control"
                            style={{
                                backgroundColor: (mainBranch && mainBranch.restaurantInformation && !mainBranch.restaurantInformation.isActive) ? "#cce5ff" : "white",
                            }}
                            disabled={mainBranch && mainBranch.restaurantInformation && !mainBranch.restaurantInformation.isActive}
                        >
                            {translator.translate("_choose_")}
                        </option>

                        {filteredBranches.filter(b => !b.deleted).map((optVal, idx) => {
                            const isInactive = optVal.restaurantInformation ? !optVal.restaurantInformation.isActive : false;
                            return (
                                <option
                                    disabled={isInactive}
                                    value={optVal._id}
                                    key={idx}
                                    selected={optVal.name === this.state.isSuggestBranchSelected}
                                    style={{
                                        backgroundColor: isInactive ? "#cce5ff" : "white",
                                    }}
                                >
                                    {optVal.name}
                                </option>
                            );
                        })}
                    </FormControl>
                </div>
            </div>
        );
    }

    renderAddress(address, i) {
        return (
            <div className={"display-flex"}>
                <label htmlFor={`address-${i}`}
                       className={"label-width"}>{translator.translate("_restaurant_address_")}:</label>
                <input
                    type={"text"}
                    id={`address-${i}`}
                    value={address}
                    disabled={true}
                    className={"form-control default-font my-custom-input"} />
            </div>
        );
    }

    renderHDMNumber(hdmNumber, i) {
        return (
            <div className={"display-flex"}>
                <label htmlFor={`hdmNumber-${i}`}
                       className={"label-width"}>{translator.translate("_hdm_number_")}:</label>
                <input
                    type={"text"}
                    id={`hdmNumber-${i}`}
                    value={hdmNumber}
                    onChange={(e) => {
                        this.props.hdmNumberHandler(e, i);
                    }}
                    disabled={!this.props.canEdit}
                    className={"form-control default-font my-custom-input"} />
            </div>
        );
    }

    handlePhoneClick(phone) {
        redirectToOkTellTab(OK_TELL_URL, phone, "_blank");
    }

    renderPhoneButton(phone, shop) {
        let restaurantInfoSup = null;
        if (shop && shop.restaurantInfo && this.props.restaurants) {
            restaurantInfoSup = this.props.restaurants.find(restaurant => restaurant._id === shop.restaurantInfo._id);
        }

        const orderId = this.props.orderId,
            status = this.props.status;
        if (status === ORDER_STATUSES.DELIVERED.statusId || status === ORDER_STATUSES.CANCELED.statusId || (shop && !shop._id)) {
            return null;
        }
        return (
            <Button
                bsStyle={shop ? SUPPLIER_STATES.stateById(shop.state).className : "success"}
                className="btn-sm phone-margin"
                onClick={() => {
                    this.handlePhoneClick(phone);
                    if (shop && restaurantInfoSup && !restaurantInfoSup.isSendToHaysell && !restaurantInfoSup.isSupplier) {
                        this.props.confirmCall(orderId, shop._id, SUPPLIER_STATES.CONFIRMED.stateId);
                    }
                }}>
                <span className="glyphicon glyphicon-earphone" />
            </Button>
        );
    }

    renderSendToPartnerButton(item, index) {
        let restaurantInfoSup = null;
        if (item.restaurantInfo && item.restaurantInfo._id && this.props.restaurants) {
            restaurantInfoSup = this.props.restaurants.find(restaurant => restaurant._id === item.restaurantInfo._id);
        }

        const activeBranches = (item.restaurantInfo.branches || restaurantInfoSup?.branches).filter((branch) => !branch.deleted);

        if (security.getUser().role !== USER_ROLES.ORDER_MANAGER) {
            return null;
        }

        if ((item.restaurantInfo && item.restaurantInfo.isSupplier) ||
            security.getUser().role !== USER_ROLES.ORDER_MANAGER) {

            let showSendButton;

            if (item?.branch) {
                showSendButton = (activeBranches?.find((branch) => branch._id === item?.branch))?.restaurantInformation.isSupplier;
            } else {
                showSendButton = item.restaurantInfo.isSupplier;
            }

            if (!showSendButton) return null;

            return (
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id={`tooltip-${item._id || item.id}`}>
                            {item.sendToPartner === undefined
                                ? "Պահպանեք ուղղարկելուց առաջ"
                                : "Ուղարկել գործընկերոջը"}
                        </Tooltip>
                    }
                >
                    <Button
                        bsStyle="success"
                        className="btn-sm phone-margin"
                        disabled={item.sendToPartner === undefined}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (restaurantInfoSup && restaurantInfoSup.isSendToHaysell) {
                                this.props.sendToHaysell(item, this.props.orderDetails._id);
                            } else {
                                this.props.sendToPartner(item, item.state === 2);
                            }
                        }}
                    >
                        <span className="glyphicon glyphicon-refresh" />
                    </Button>
                </OverlayTrigger>
            );
        }
    }

    renderConfirmLabel(shop, isDraft, index) {
        // const copyOrderShops = this.props.originalOrderShops[index]?.restaurantInfo;
        //
        // const currentBranch = (shop.branch === "" || shop.branch === null) ? copyOrderShops?.mainBranch : copyOrderShops?.branches.find((br) => br._id === shop.branch);
        //
        // const isDraft = currentBranch?.status === 0;

        if (shop.hasOwnProperty("state")) {
            const partnerResponse = shop.partner || {};
            const readyDeliveryDate = (shop.state === SUPPLIER_STATES.READY_TO_DELIVERY.stateId
                && shop.readyToDeliveryDate && shop.readyToDeliveryDate.length) ? shop.readyToDeliveryDate[0] : null;

            return (
                <span>
                    <Label
                        bsStyle={isDraft ? SUPPLIER_STATES.stateById(0).className : SUPPLIER_STATES.stateById(shop.state).className}
                        className="phone-margin">
                        {isDraft ? translator.translate("_draft_") : translator.translate(SUPPLIER_STATES.stateById(shop.state).name)}
                        {readyDeliveryDate && " (" + moment(readyDeliveryDate).format("DD/MM/YYYY HH:mm") + ")"}
                    </Label>
                    <span> {partnerResponse.message} </span>
                </span>
            );
        }
        return null;
    }

    renderPhoneNumberAndButton(phone, index = 0, i = 0, shop) {
        if (phone) {
            return (
                <div key={index}>
                    <div className="form-group">
                        <span className="flex-box">
                            <input
                                type={"text"}
                                id={`phoneNumbers-${index}-${i}`}
                                value={phone}
                                disabled={true}
                                className={"form-control default-font input-width"} />
                            {this.renderPhoneButton(phone, shop)}
                        </span>
                    </div>
                </div>
            );
        }
    }

    renderPhoneNumbers(phoneNumbers, i, shop) {
        return (
            <div className={"display-flex"}>
                <label htmlFor={`phoneNumbers-${i}`}
                       className={"label-width"}>{translator.translate("_restaurant_phone_")}:</label>
                <div className="flex-box direction-column">
                    {
                        phoneNumbers?.map((phone, index) => {
                            return this.renderPhoneNumberAndButton(phone, index, i, shop);
                        })
                    }
                </div>
            </div>
        );
    }

    renderRestaurantInfo(data, branches, branch, i, shop) {
        const selectedBranch = branches.find(b => b._id === this.state.branchId);

        const info = selectedBranch ? (selectedBranch && selectedBranch.restaurantInformation) : data.restaurantInformation;

        const normalizedBranches = (branches || []).map(b => ({
            ...b,
            restaurantInformation: {
                ...b.restaurantInformation,
                isActive:
                    b.restaurantInformation && typeof b.restaurantInformation.isActive !== "undefined"
                        ? b.restaurantInformation.isActive
                        : info.isActive,
            },
        }));

        const address =
            info.location && info.location.address ? info.location.address : null;
        const phoneNumbers = info.phoneNumbers || null;
        const suggestedBranch = shop && shop.suggestedBranch ? shop.suggestedBranch : null;
        const hdmNumber = shop && shop.hdmNumber ? shop.hdmNumber : null;

        return (
            <div>
                {this.renderBranches(normalizedBranches, branch, i, suggestedBranch)}
                {this.renderAddress(address, i)}
                {this.renderPhoneNumbers(phoneNumbers, i, shop)}
                {this.renderHDMNumber(hdmNumber, i)}
            </div>
        );
    }

    render() {
        return (
            <ListGroup fill="true" className={`padding-vertical`}>
                {
                    Array.isArray(this.state.shops) && this.state.shops.map((item, i) => {
                        const priceAdditionalStyle = this.propertyWasChanged("price", i) ? "was-changed" : "",
                            collectedOrderAmountAdditionalStyle = this.propertyWasChanged("collectedOrderAmount", i) ? "was-changed" : "",
                            driverExpensesAdditionalStyle = this.propertyWasChanged("driverExpenses", i) ? "was-changed" : "",
                            readyTimeAdditionalStyle = this.propertyWasChanged("readyTime", i) ? "was-changed" : "",
                            restaurantInfo = this.getRestaurantInfo(item);
                        let disabled = security.getUser().role === USER_ROLES.SUPER_ADMIN ? "" : "disabled";
                        let key = item._id;
                        if (!key && restaurantInfo && restaurantInfo._id) {
                            key = restaurantInfo._id;
                        } else {
                            key = i;
                        }
                        let branches = [],
                            branchInfo = null;
                        if (restaurantInfo) {
                            let branchesArray = restaurantInfo.branches || [];

                            if (!branchesArray || branchesArray.length === 0) {
                                const restaurantFromProps = this.props.restaurants?.find(r => r._id === restaurantInfo._id);
                                if (restaurantFromProps && restaurantFromProps.branches && restaurantFromProps.branches.length > 0) {
                                    branchesArray = restaurantFromProps.branches;
                                }
                            }

                            const allBranches = [
                                ...branchesArray,
                                {

                                    _id: "mainBranch",
                                    name: "Main Branch",
                                    restaurantInformation: {
                                        ...restaurantInfo.mainBranch,
                                    },
                                },
                            ];

                            branches = allBranches.filter(
                                branch => {
                                    const keep = !branch.deleted || branch._id === item.branch;
                                    if (!keep) {
                                    }
                                    return keep;
                                },
                            );

                            if (item.branch) {
                                branchInfo = this.getBranchInfo(branches, item.branch);
                            }
                        }
                        const expanded = (this.state.collapses[key] && this.state.collapses[key].open);

                        return (
                            <Panel
                                key={i}
                                expanded={expanded}
                                toggle="true"
                                defaultExpanded={this.props.expanded}
                                onToggle={() => {
                                }}
                                className="nested-custom-panel">
                                <Panel.Heading onClick={this.handleCollapsesToggle(key, this.props.expanded)}>
                                    {this.renderHeader((branchInfo || restaurantInfo), item, branches, i)}
                                </Panel.Heading>
                                <Panel.Collapse>
                                    <Panel.Body>
                                        {this.renderRestaurantInfo((branchInfo || restaurantInfo), branches, item.branch || "", i, item)}
                                        {this.renderProducts(item, i)}
                                        {this.renderInput("_price_", `price-${i}`, "number", item.price, (e) => {
                                            this.props.priceHandler(e, i);
                                        }, priceAdditionalStyle)}
                                        {this.renderInput("_partner_debt_", `driverExpenses-${i}`, "number", item.driverExpenses, (e) => {
                                            this.props.driverExpensesHandler(e, i);
                                        }, driverExpensesAdditionalStyle)}
                                        {this.renderInput("_delivery_price_label_", `delivery-${i}`, "number", item.deliveryPrice, () => {
                                        }, driverExpensesAdditionalStyle, "", "", "disabled")}
                                        {this.renderInput("_delivery_campain_id_", `delivery-campaign-id-${i}`, "number", item.deliveryCampaignId, () => {
                                        }, driverExpensesAdditionalStyle, "", "", "disabled")}
                                        {this.renderInput("_collected_order_amount_", `collected-order-amount-${i}`, "number", item.collectedOrderAmount, (e) => {
                                            this.props.collectedOrderAmountHandler(e, i);
                                        }, collectedOrderAmountAdditionalStyle, "", "", disabled)}
                                        {this.renderDateTimePicker("_ready_time_", `readyTime-${i}`, {
                                            ...item,
                                            shopIndex: i,
                                        }, (e) => {
                                            let readyTime = typeof e === "string" ? e : moment(e).format("DD/MM/YYYY HH:mm");
                                            this.setState({ isRequiredReadyTime: readyTime.length !== 16 });
                                            this.props.modalCanSave(readyTime.length === 16);
                                            if ("function" === typeof e.format) {
                                                this.props.readyTimeHandler(e, i);
                                                this.props.dateValidation();
                                            }
                                        }, readyTimeAdditionalStyle)}
                                    </Panel.Body>
                                </Panel.Collapse>
                            </Panel>
                        );
                    })
                }
            </ListGroup>
        );
    }
}

let mapStateToProps = (state) => {
    return {
        orderDetails: state.orderDetails,
        order: state,
    };
};

export default connect(
    mapStateToProps, {
        confirmCall,
        sendToHaysell,
    })(ShopList);
